/** Retail pouch photos — replace files in public/products/ with your WhatsApp pack shots (same filenames). */
export const PACKET_IMAGES = {
  mixture: `${process.env.PUBLIC_URL}/products/mixture-packet.jpg`,
  bhujiaSev: `${process.env.PUBLIC_URL}/products/bhujia-sev-packet.jpg`,
  moongDal: `${process.env.PUBLIC_URL}/products/moong-dal-packet.jpg`,
};
